import React, { useMemo } from "react"
import { useSnapshot } from "valtio"
import { wizardStore } from "../../../../stores/wizard"
import { getColorStyle } from "../../../../actions/wizard"
import { ICircle, StepOption } from "../../../../types/wizard"

interface IColorItems {
  items: ICircle[];
}

interface IColorSummaryProps {
  content: StepOption;
  showTitle?: boolean;
  showNote?: boolean;
}

export const ColorSummary: React.FC<IColorSummaryProps> = ({ content, showTitle = true, showNote = true }) => {
  const wizSnap = useSnapshot(wizardStore)

  const colorStyleDiv = useMemo(() => getColorStyle(content), [content])

  return (
    <>
      <div className="flex flex-col self-start text-md font-bold py-1">
        {showTitle && <h3 className="mb-2">Colour Selected:</h3>}
        {content ? (
          <div className="flex gap-2 items-center">
            <div className="rounded-full w-5 h-5 border border-slate-300" style={{ ...colorStyleDiv }}></div>
            <p>{content?.name}</p>
          </div>
        ) : null}
      </div>
      {wizSnap.step?.disclaimer && showNote ? (
        <div className="mt-8 text-left text-sm" dangerouslySetInnerHTML={{ __html: wizSnap.step?.disclaimer.message }} />
      ) : null}
    </>
  )
}

export const ColorsSummary: React.FC<{ content: IColorItems }> = ({ content }) => {
  const wizSnap = useSnapshot(wizardStore)

  return (
    <>
      <h3 className="text-left mb-2 font-bold">{content?.items?.length} Colours Selected:</h3> 
      {content?.items.map((item, index) => (
        <ColorSummary key={index} content={item.option as StepOption} showTitle={false} showNote={false} />
      ))}
      {wizSnap.step?.disclaimer ? (
        <div className="mt-8 text-left text-sm" dangerouslySetInnerHTML={{ __html: wizSnap.step?.disclaimer.message }} />
      ) : null}
    </>
  )
}
